import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchSalesPersonReport_api = async (
  startDate: string,
  endDate: string,
  salesPersonId: string = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Reports/fetch_sales_person_report.php`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          startDate,
          endDate,
          salesPersonId,
        },
      },
    );

    return response.data;
  } catch (error: any) {
    console.error("Fetch sales person report failed:", error);
    return { error: "Fetch sales person report failed" };
  }
};
